import type { NormalisedRequest } from '@onhandtech/onhand-fe-shared/lib/api/v4/requests/requests.types'
import type { PatchRequestPayload } from '@onhandtech/onhand-fe-shared/lib/contracts/api/v4/requests/requests'
import { formatEndpoint } from '@onhandtech/onhand-fe-shared/lib/request'
import type { PayloadAction } from '@reduxjs/toolkit'
import { patchRequest } from 'redux/redux-modules'
import { getRequestPayload } from 'redux/redux-modules/v4/post-patch-request/post-patch-request.utils'
import { put, select } from 'redux-saga/effects'

import { getConfig } from '../../../../config/configuration'
import type { PatchSelectedRequestPayload } from '../actions'
import { setPatchRequestType } from '../actions'
import { draftRequestSelector, selectedRequestSelector } from '../selectors'

export function* patchSelectedRequestSaga(action: PayloadAction<PatchSelectedRequestPayload>) {
  const { formatMessage, patchRequestType, requestId } = action.payload

  yield put(setPatchRequestType(patchRequestType))

  const selectedRequest: NormalisedRequest = yield select(selectedRequestSelector)
  const draftRequest: NormalisedRequest = yield select(draftRequestSelector)

  const requestPayload: Omit<PatchRequestPayload, 'cover_image_files'> = {
    approved: patchRequestType === 'approve',
    ...getRequestPayload(selectedRequest, draftRequest),
  }

  yield put(
    patchRequest.actions.makeRequest(
      {
        url: formatEndpoint(getConfig().endpoints.api.v4.requestById, { id: requestId }),
        payload: requestPayload,
      },
      formatMessage,
    ),
  )
}
